import { parse } from '../../util/urlHelpers';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { addMarketplaceEntities, getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  currentShiftTransitions,
  pastShiftTransitions,
  upcomingShiftTransitions,
} from '../../util/transaction';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { earningFetchType } from '../../marketplace-custom-config';
import moment from 'moment';
import { apiBaseUrl } from '../../util/api';
import axios from 'axios';
import { storableError } from '../../util/errors';
import { timestatementTab } from '../WorkerTimestatementPage/constant';
import { types as sdkTypes } from '../../util/sdkLoader';

const { UUID } = sdkTypes;

const RESULT_PAGE_SIZE = 10;

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );
const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

export const FETCH_WORKING_STAFF_REQUEST = 'app/WorkerDashboardPage/FETCH_WORKING_STAFF_REQUEST';
export const FETCH_WORKING_STAFF_SUCCESS = 'app/WorkerDashboardPage/FETCH_WORKING_STAFF_SUCCESS';
export const FETCH_WORKING_STAFF_ERROR = 'app/WorkerDashboardPage/FETCH_WORKING_STAFF_ERROR';

export const FETCH_WORKING_EARNING_REQUEST =
  'app/WorkerDashboardPage/FETCH_WORKING_EARNING_REQUEST';
export const FETCH_WORKING_EARNING_SUCCESS =
  'app/WorkerDashboardPage/FETCH_WORKING_EARNING_SUCCESS';
export const FETCH_WORKING_EARNING_ERROR = 'app/WorkerDashboardPage/FETCH_WORKING_EARNING_ERROR';

export const FETCH_WORKING_JOBS_REQUEST = 'app/WorkerDashboardPage/FETCH_WORKING_JOBS_REQUEST';
export const FETCH_WORKING_JOBS_SUCCESS = 'app/WorkerDashboardPage/FETCH_WORKING_JOBS_SUCCESS';
export const FETCH_WORKING_JOBS_ERROR = 'app/WorkerDashboardPage/FETCH_WORKING_JOBS_ERROR';

// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchAllWorkersError: null,
  pagination: null,
  // currentPageWorkers: [],
  workingStaffs: [],
  workingStaffsRequest: false,
  workingStaffsError: null,
  workerEarnings: {},
  workerEarningsInProgress: false,
  workerEarningsError: null,
  workerJobs: [],
  workerJobsPagination: {},
  workerJobsInProgress: false,
  workerJobsError: null,
};

export default function WorkerDashboardPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_WORKING_STAFF_REQUEST:
      return {
        ...state,
        fetchInProgress: true,
        workingStaffsRequest: true,
        fetchAllWorkersError: null,
        workingStaffs: [],
      };
    case FETCH_WORKING_STAFF_SUCCESS:
      const transactions = sortedTransactions(payload.data.data);

      return {
        ...state,
        workingStaffsRequest: false,
        workingStaffs: entityRefs(transactions),
        pagination: payload.data.meta,
        fetchInProgress: false,
      };
    case FETCH_WORKING_STAFF_ERROR:
      return { ...state, workingStaffsRequest: false, fetchAllWorkersError: payload };

    case FETCH_WORKING_EARNING_REQUEST:
      return { ...state, workerEarningsInProgress: true, workerEarningsError: null };
    case FETCH_WORKING_EARNING_SUCCESS:
      return { ...state, workerEarningsInProgress: false, workerEarnings: payload };
    case FETCH_WORKING_EARNING_ERROR:
      return { ...state, workerEarningsInProgress: false, workerEarningsError: payload };

    case FETCH_WORKING_JOBS_REQUEST:
      return { ...state, workerJobsInProgress: true, workerJobsError: null };
    case FETCH_WORKING_JOBS_SUCCESS:
      return {
        ...state,
        workerJobsInProgress: false,
        workerJobs: payload.data,
        workerJobsPagination: payload.meta,
      };
    case FETCH_WORKING_JOBS_ERROR:
      return { ...state, workerJobsInProgress: false, workerJobsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //
export const fetchWorkingStaffRequest = () => ({ type: FETCH_WORKING_STAFF_REQUEST });
export const fetchWorkingStaffSuccess = response => {
  return {
    type: FETCH_WORKING_STAFF_SUCCESS,
    payload: response,
  };
};
export const fetchWorkingStaffError = e => ({
  type: FETCH_WORKING_STAFF_ERROR,
  error: true,
  payload: e,
});

export const fetchWorkingEarningRequest = () => ({ type: FETCH_WORKING_EARNING_REQUEST });
export const fetchWorkingEarningSuccess = data => {
  return {
    type: FETCH_WORKING_EARNING_SUCCESS,
    payload: data,
  };
};
export const fetchWorkingEarningError = e => ({
  type: FETCH_WORKING_EARNING_ERROR,
  error: true,
  payload: e,
});

export const fetchWorkingJobsRequest = () => ({ type: FETCH_WORKING_JOBS_REQUEST });
export const fetchWorkingJobsSuccess = data => {
  return {
    type: FETCH_WORKING_JOBS_SUCCESS,
    payload: data,
  };
};
export const fetchWorkingJobsError = e => ({
  type: FETCH_WORKING_JOBS_ERROR,
  error: true,
  payload: e,
});
// ================ Thunk ================ //

async function queryTimestatement(query) {
  let page = 1,
    totalPages = 1;
  const timestatements = [];
  query.perPage = 100;
  const url = `${apiBaseUrl()}/api/timeStatement/get`;
  for (; page <= totalPages; page++) {
    query.page = page;
    const resp = await axios.get(url, { params: query });
    const { data, meta } = resp.data;
    const txData = data.filter(res => !!res.transactionId).map(r => new UUID(r.transactionId));
    timestatements.push(...txData);
    totalPages = meta.totalPages;
    query.lastPageId = data[data.length - 1]?._id;
  }
  return timestatements;
}

const currentUnShiftWorks = async (sdk, workerId, includeParams) => {
  const userOffset = moment().utcOffset();
  const date = moment()
    .add(userOffset, 'm')
    .toISOString();
  const query = { workerId, tab: timestatementTab.recent, date, isDispute: true };
  const results = await queryTimestatement(query);
  const txResults = await Promise.all(
    results.map(r => sdk.transactions.show({ id: r, ...includeParams }))
  );

  const defaultStatus = {
    status: 200,
    statusText: '',
    data: {
      data: [],
      included: [],
      meta: {
        totalItems: txResults.length,
        totalPages: 1,
        page: 1,
        perPage: txResults.length,
      },
    },
  };
  const transitions = txResults.reduce((acc, item) => {
    const {
      data: { data, included = [] },
    } = item;
    acc.data.data.push(data);
    acc.data.included.push(...included);
    return acc;
  }, defaultStatus);

  return transitions;
};

const waitUntillCurrentUserLoaded = (getState, retryInterval = 50) => {
  return new Promise((resolve, reject) => {
    let intervalId = null;
    const checkCurrentUserLoaded = () => {
      const { currentUser } = getState().user;
      const { isAuthenticated } = getState().Auth;

      const isCurrentUserLoaded = isAuthenticated
        ? !!(currentUser && currentUser.id && currentUser.id.uuid)
        : true;
      if (isCurrentUserLoaded) {
        if (intervalId) clearInterval(intervalId);
        resolve(currentUser || null);
      }
    };

    intervalId = setInterval(checkCurrentUserLoaded, retryInterval);
    checkCurrentUserLoaded();
  });
};

export const fetchWorkingStaffShifts = param => async (dispatch, getState, sdk) => {
  const { page = 1, tab, workerId, dispatchSuccessAction } = param;
  dispatch(fetchWorkingStaffRequest());

  await dispatch(fetchCurrentUser());
  const fetchedcurrentUser = getState().user.currentUser;
  const isProvider =
    fetchedcurrentUser && fetchedcurrentUser?.attributes?.profile.publicData.isProvider;

  const lastTransitions =
    tab === 'upcomingShifts'
      ? upcomingShiftTransitions
      : tab === 'currentShifts'
      ? currentShiftTransitions
      : tab === 'pastShifts'
      ? pastShiftTransitions
      : [];

  const includeparamsForWorker = {
    include: [
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
      'listing',
    ],
    'fields.transaction': [
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
    ],

    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };
  const includeParamsForBusiness = {
    include: [
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
      'listing',
    ],
    'fields.transaction': [
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
    ],

    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'profile.publicData'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
  };
  const paramForWorker = {
    lastTransitions,
    //   userId: ,
    only: 'order',
    ...includeparamsForWorker,
    page,
    per_page: RESULT_PAGE_SIZE,
  };
  const paramForBusiness = {
    lastTransitions,
    userId: workerId,
    only: 'sale',
    ...includeParamsForBusiness,
    page,
    per_page: RESULT_PAGE_SIZE,
  };
  const queryPromise =
    tab === 'currentShifts'
      ? currentUnShiftWorks(
          sdk,
          workerId,
          isProvider ? includeParamsForBusiness : includeparamsForWorker
        )
      : sdk.transactions.query(isProvider ? paramForBusiness : paramForWorker);

  return queryPromise
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      if (dispatchSuccessAction) dispatch(fetchWorkingStaffSuccess(response));

      return response;
    })
    .catch(e => {
      fetchWorkingStaffError(e);
    });
};

export const fetchWorkerEarningTotal = () => (dispatch, getState, sdk) => {
  dispatch(fetchWorkingEarningRequest());
  const url = `${apiBaseUrl()}/api/user/worker/earnings/total`;
  return axios
    .get(url, { withCredentials: true })
    .then(resp => {
      dispatch(fetchWorkingEarningSuccess(resp.data));
    })
    .catch(err => {
      dispatch(fetchWorkingEarningError(storableError(err)));
    });
};
export const fetchEarning = param => async (dispatch, getState, sdk) => {
  try {
    dispatch(fetchWorkingJobsRequest());
    const { box = earningFetchType.lastWeek, startDate, endDate, page } = param || {};

    let query = `?dateRange=${box}&page=${page || 1}`;
    if (endDate && startDate) {
      query = `&startDate=${startDate}&endDate=${endDate}`;
    } else if (endDate) {
      query = `&endDate=${endDate}`;
    }
    const workerUrl = `${apiBaseUrl()}/api/user/worker/earnings${query}`;
    const resp = await axios.get(workerUrl, { withCredentials: true });
    dispatch(fetchWorkingJobsSuccess(resp.data));
  } catch (e) {
    dispatch(fetchWorkingJobsError(storableError(e)));
  }
};
export const loadData = (params, search) => async (dispatch, getState, sdk) => {
  const queryParams = parse(search);
  const queryPage = queryParams.page || 1;
  const box = queryParams.box || earningFetchType.lastWeek;
  const tab = queryParams.tab || 'currentShifts';
  const slug = params.slug;
  if (tab === 'earning') {
    dispatch(fetchWorkerEarningTotal());
    dispatch(fetchEarning({ box, page: queryPage }));
  }
  return waitUntillCurrentUserLoaded(getState).then(currentUser => {
    if (!currentUser) return Promise.reject();
    const {
      id: { uuid: workerId },
    } = currentUser;
    if (queryParams.workerId === undefined) {
      queryParams.workerId = workerId;
    }
    return dispatch(fetchWorkingStaffShifts({ ...queryParams, tab, dispatchSuccessAction: true }));
  });
};
